import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getPlanning = (user_id, start_date, end_date) => {
    return request({
        url: namespace + `/planning/${user_id}/${start_date}/${end_date}`,
        method: "get",
    });
};

export const getPlanningTeam = (team_id, start_date, end_date) => {
    return request({
        url: namespace + `/planning/team/${team_id}/${start_date}/${end_date}`,
        method: "get",
    });
};

export const getHolidays = (start_date, end_date) => {
    return request({
        url: namespace + `/planning/holidays/${start_date}/${end_date}`,
        method: "get",
    });
};

export const getDailyFollowUpReport = (start_date, end_date) => {
    return request({
        url: namespace + "/planning/daily-follow-up",
        method: "get",
        params: { start_date, end_date },
    });
};

export const addManualBadgeage = (payload) => {
    return request({
        url: namespace + "/planning/daily-follow-up/badgeage",
        method: "post",
        data: payload,
    });
};

export const deleteBadgeage = (id) => {
    return request({
        url: namespace + `/planning/daily-follow-up/badgeage/${id}`,
        method: "delete",
    });
};

export const createTimeSlot = (payload) => {
    return request({
        url: namespace + `/timeslot`,
        data: payload,
        method: "post",
    });
};

export const updateTimeSlot = (ts_id, payload) => {
    return request({
        url: namespace + `/timeslot/${ts_id}`,
        data: payload,
        method: "put",
    });
};

export const updateTimeSlots = (payload) => {
    return request({
        url: namespace + `/timeslots`,
        data: payload,
        method: "post",
    });
};

export const applyDayModelToTimeSlots = (payload) => {
    return request({
        url: namespace + `/timeslots/apply-daymodel`,
        data: payload,
        method: "post",
    });
};

export const destroyTimeSlot = (ts_id, { force = false } = {}) => {
    return request({
        url: namespace + `/timeslot/${ts_id}`,
        method: "delete",
        params: force ? { force: 1 } : {},
    });
};

export const checkTimeSlotPresence = (params) => {
    return request({
        url: namespace + `/timeslot/check-presence`,
        params: params,
        method: "get",
    });
};
